import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hiddenLoader } from "../stores/loading";
import { fetchAPI } from "../utils/api";
import { getDateTimeWithDayEN } from "../utils/Utils";
import { Form } from "./form/Form";
import { Table } from "./table/Table";

export default function Escrow() {
    const dispatch = useDispatch();
    const [formState, setFormState] = useState({} as any);
    const [resultEscrow, setResultEscrow] = useState([] as any);

    function search(form: any, page: number = 0) {
        form = { ...form, escrow_transfer_start_date : getDateTimeWithDayEN(form.escrow_transfer_start_date), escrow_transfer_thru_date : getDateTimeWithDayEN(form.escrow_transfer_thru_date) };
        setFormState(form);
        fetchAPI(`/commissions/search_escrow?page=${page}&size=15`, {
            method: "POST",
            body: JSON.stringify(form)
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then(setResultEscrow);

    }

    function reset() {
        setResultEscrow([])
    }

    let form = {
        "escrow_transfer_start_date": "date",
        "escrow_transfer_thru_date": "date",
        "escrow_transfer_id": "string"
    }

    let headers = [
        "escrow_transfer_id",
        "operator",
        "amount",
        "total_commissions",
        "total_orders"
    ]


    let clickables = {
        "escrow_transfer_id": "/commission?escrow_transfer_id="
    }

    return (<>
        <div className="vtmn-p-4">
            <Form
                form={form}
                search={(form: any, page: number) => search(form)}
                reset={() => reset()}
            />
        </div>
        <div>
            {resultEscrow?.content?.length > 0 &&
                <Table
                    result={resultEscrow}
                    headers={headers}
                    clickables={clickables}
                    changePage={(page: number) => search(formState, page)}
                />}
            {resultEscrow.status === 404 && <p className="vtmn-text-center">No Result</p>}
        </div>
    </>
    )
}